'use strict';

var Sugar = require('sugar-core'),
    ARRAY_OPTIONS = require('./var/ARRAY_OPTIONS');

var _arrayOptions = ARRAY_OPTIONS._arrayOptions;

module.exports = Sugar.Array.getOption;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/getOption.js
// module id = 380
// module chunks = 0